<header class="top-nav-container">
  <div class="top-nav-unlogged">
    <div class="next-logo" routerLink="/">
      <img src="assets/icons/header/new_logo_next.png" alt="">
      @if (titleText) {
        <span>|</span>
      }
      <span>{{ titleText }}</span>
    </div>
  </div>
  <div class="next-logo-container">
    <app-language-selector class="language-selector"></app-language-selector>
    <app-clock></app-clock>
  </div>
</header>